import { NavLink } from 'react-router-dom';
import { Text, TextProps } from '../../Atoms/Text';
import { Icon, IconProps } from '../../Atoms/Icon';

interface navLinkProps {
  to: string;
  className?: string;
}

export interface SideBarItemProps {
  className?: string;
  navLinkProps: navLinkProps;
  iconProps?: IconProps;
  textProps: TextProps;
  active: boolean;
  dataCy?: string;
  dataTestId?: string;
  // The collapsed sidebar clips a long label to an icon-strip width by default; a sub-nav item in
  // a fixed-width panel (never collapsed) can opt into wrapping its label instead.
  wrap?: boolean;
}

export const SideBarItem = ({
  className = 'w-full',
  navLinkProps,
  iconProps,
  textProps,
  active,
  dataCy,
  dataTestId,
  wrap = false
}: SideBarItemProps) => {
  const baseNavLinkProps = 'bg group flex items-center space-x-4 m-2 p-2 pl-1 text-black hover:bg-grey-2 rounded';
  const noWrapNavLinkProps = 'overflow-hidden whitespace-nowrap hover:min-w-max';
  const defaultNavLinkProps = wrap ? baseNavLinkProps : `${baseNavLinkProps} ${noWrapNavLinkProps}`;

  const navLinkClassName = navLinkProps.className || `${defaultNavLinkProps}${active ? ' bg-grey-2' : ''}`;
  const textClassName = textProps.className || 'group-hover:text-gray-700 z-1000';
  return (
    <li className={className}>
      <NavLink
        {...navLinkProps}
        data-cy={dataCy}
        data-testid={dataTestId}
        className={navLinkClassName}>
        {iconProps ? <Icon {...iconProps} /> : null}
        <Text
          {...textProps}
          color="black"
          className={textClassName}
          weight={textProps.weight || 'normal'}
        />
      </NavLink>
    </li>
  );
};
